<div style="background-color: white">
    <div class="pl-4 pr-4 pb-4 pt-3">
        <div class="row pb-1">
            <div class="col-12 text-right">
                <input id="{{'startswith'+context}}" type="radio" kendoRadioButton [(ngModel)]="operator"
                    (click)="changeFilterOperator('startsWith')" name="{{'operator' + context}}" value="startsWith"
                    [disabled]="!searchEnabled" />
                <label class="ml-1" for="{{'startswith'+context}}">{{'OPERATOR-STARTS-WITH' | translate}}</label>
                <input id="{{'contains'+context}}" class="ml-2" type="radio" kendoRadioButton [(ngModel)]="operator"
                    (click)="changeFilterOperator('contains')" name="{{'operator' + context}}" value="contains"
                    [disabled]="!searchEnabled" />
                <label class="ml-1" for="{{'contains'+context}}">{{'OPERATOR-CONTAINS' | translate}}</label>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-12">
                <kendo-multicolumncombobox #combobox [data]="subjectItems" [textField]="'fullName'" [valueField]="'id'"
                    class="w-100" [suggest]="true" [loading]="loadingSubjects" [disabled]="!searchEnabled"
                    placeholder="{{'SEARCH-MEMBER' | translate:patientLabel }}" [filterable]="true"
                    (valueChange)="onChangeSubject($event)" (filterChange)="handleSubjectFilterChange($event)"
                    [popupSettings]="{ popupClass: 'subject-popup'}" [valuePrimitive]="false"
                    [(ngModel)]="selectedSubject" (open)="handleOpenSubject($event)">
                    <kendo-combobox-column field="fullName" title="{{'NAME'|translate}}" [width]="50"
                        [headerClass]="'subject-popup'">
                    </kendo-combobox-column>
                    <kendo-combobox-column [field]="'dateOfBirth'" title="{{'DOB' | translate}}" [width]="40"
                        [headerClass]="'subject-popup'">
                    </kendo-combobox-column>
                    <kendo-combobox-column [field]="'streetLine'" title="{{'ADDRESS' | translate}}" [width]="100"
                        [headerClass]="'subject-popup'">
                        <ng-template kendoMultiColumnComboBoxColumnCellTemplate let-dataItem>
                            <span>{{dataItem.streetLine}} {{dataItem.streetLineAdditional}}<br /></span>
                            <span *ngIf="dataItem.city">{{dataItem.city}}</span>
                            <span *ngIf="dataItem.county">{{dataItem.city ? ', ' + dataItem.county :
                                dataItem.county}}</span>
                            <span *ngIf="dataItem.stateCode">{{dataItem.city || dataItem.county ? ', ' +
                                dataItem.stateCode:dataItem.stateCode}}</span>
                            <span *ngIf="dataItem.postalCode">{{dataItem.city || dataItem.county || dataItem.stateCode ?
                                ', ' + dataItem.postalCode : dataItem.postalCode}}</span>
                        </ng-template>
                    </kendo-combobox-column>
                    <kendo-combobox-column [field]="'id'" title="{{'ID' | translate}}" [width]="40"
                        [headerClass]="'subject-popup'">
                    </kendo-combobox-column>
                </kendo-multicolumncombobox>
            </div>
        </div>
        <kendo-panelbar>
            <kendo-panelbar-item>
                <ng-template kendoPanelBarItemTitle>
                    {{'DEMOGRAPHICS' | translate }}<span *ngIf="demographicCount > 0"
                        class="badge-merge badge-pill badge-secondary"
                        title="{{'DEMOGRAPHICS' | translate}}">{{demographicCount}}</span>
                </ng-template>
                <ng-template kendoPanelBarContent>
                    <kendo-grid [data]="viewDemographics.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
                        [sort]="viewDemographics.state.sort" [resizable]="true" class="max-grid-height"
                        (dataStateChange)="dataStateChange(viewDemographics,$event)" [loading]="loadingSubjects">
                        <kendo-grid-messages noRecords="{{ 'NO-DEMOGRAPHICS' | translate }}">
                        </kendo-grid-messages>
                        <kendo-grid-column field="name" [width]="50" title="{{ 'NAME' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="value" [width]="50" title="{{ 'VALUE' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="context === 'source' && propertiesSelectorVisible" class="text-center"
                            field="selected" [width]="25"
                            title="{{ 'PATIENT-MERGE-SOURCE-DEMOGRAPHICS' | translate:patientLabel }}" filter="boolean">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span
                                    *ngIf="dataItem.value !== null && dataItem.key !== 'id' && dataItem.key !== 'addresses'">
                                    <input type="checkbox" [(ngModel)]="dataItem.selected" kendoCheckBox
                                        [disabled]="!propertiesSelectorEnabled" />
                                </span>
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item>
                <ng-template kendoPanelBarItemTitle>
                    {{membersInMyHousehold}}<span *ngIf="householdMembersCount > 0"
                        class="badge-merge badge-pill badge-secondary"
                        title="{{membersInMyHousehold}}">{{householdMembersCount}}</span>
                </ng-template>
                <ng-template kendoPanelBarContent>
                    <kendo-grid [data]="viewHouseholdMembers.gridData" [selectable]="{ mode: 'single' }"
                        [sortable]="true" [sort]="viewHouseholdMembers.state.sort" [resizable]="true"
                        class="max-grid-height" (dataStateChange)="dataStateChange(viewHouseholdMembers,$event)"
                        [loading]="viewHouseholdMembers.loading">
                        <kendo-grid-messages noRecords="{{ 'NO-HOUSEHOLD-MEMBERS' | translate }}">
                        </kendo-grid-messages>
                        <kendo-grid-column field="fullName" [width]="20" title="{{ 'NAME' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="relationship" [width]="20" title="{{ 'RELATIONSHIP' | translate }}">
                        </kendo-grid-column>
                    </kendo-grid>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item *ngIf="attachmentsEnabled">
                <ng-template kendoPanelBarItemTitle>
                    {{'DOCUMENTS' | translate}}<span *ngIf="documentCount > 0"
                        class="badge-merge badge-pill badge-secondary"
                        title="{{'DOCUMENTS' | translate}}">{{documentCount}}</span>
                </ng-template>
                <ng-template kendoPanelBarContent>
                    <kendo-grid [data]="viewDocuments.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
                        [sort]="viewDocuments.state.sort" [resizable]="true" class="max-grid-height"
                        (dataStateChange)="dataStateChange(viewDocuments,$event)" [loading]="viewDocuments.loading">
                        <kendo-grid-messages noRecords="{{ 'NO-DOCUMENTS' | translate }}">
                        </kendo-grid-messages>
                        <kendo-grid-column field="description" [width]="40" title="{{ 'NAME' | translate }}">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <i class="fas fa-file fa-lg mr-1" class="fa {{getFileTypeClass(dataItem.mediaType)}}"
                                    title="{{dataItem.description}}"></i><span
                                    title="{{dataItem.description}}">{{dataItem.description}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="mediaType" [width]="20" title="{{ 'DOCUMENT-TYPE' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="date" [width]="22" title="{{ 'DATE' | translate }}" filter="date"
                            format="{0:d}">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div *ngIf="dataItem.date!==null">{{ intl.formatDate(intl.parseDate(dataItem.date), "g")
                                    }}</div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-command-column [width]="10" title="{{ 'ACTIONS' | translate }}"
                            class="text-center p-0">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <i *ngIf="dataItem.url" class="fas fa-eye fa-lg" title="{{ 'VIEW' | translate }}"
                                    (click)="viewDocumentHandler(dataItem['url'], dataItem['description'], dataItem['mediaType'], dataItem['date'])">
                                </i>
                            </ng-template>
                        </kendo-grid-command-column>
                    </kendo-grid>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item>
                <ng-template kendoPanelBarItemTitle>
                    {{'CARE-TEAM' | translate }}<span *ngIf="careTeamCount > 0"
                        class="badge-merge badge-pill badge-secondary"
                        title="{{'CARE-TEAM' | translate}}">{{careTeamCount}}</span>
                </ng-template>
                <ng-template kendoPanelBarContent>
                    <kendo-grid [data]="viewCareTeams.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
                        [sort]="viewCareTeams.state.sort" [resizable]="true" class="max-grid-height"
                        (dataStateChange)="dataStateChange(viewCareTeams,$event)" [loading]="viewCareTeams.loading">
                        <kendo-grid-messages noRecords="{{ 'NO-CARE-TEAM' | translate }}">
                        </kendo-grid-messages>
                        <kendo-grid-column field="name" [width]="60" title="{{ 'NAME' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="teamRole" [width]="60" title="{{ 'ROLE' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="teamSubRole" [width]="60" title="{{ 'SUBROLE' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="organization" [width]="60" title="{{ 'ORGANIZATION' | translate }}">
                        </kendo-grid-column>
                    </kendo-grid>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item>
                <ng-template kendoPanelBarItemTitle>
                    {{'CASES' | translate }}<span *ngIf="caseCount > 0" class="badge-merge badge-pill badge-secondary"
                        title="{{'CASES' | translate}}">{{caseCount}}</span>
                </ng-template>
                <ng-template kendoPanelBarContent>
                    <kendo-grid [data]="viewCases.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
                        [sort]="viewCases.state.sort" [resizable]="true" class="max-grid-height"
                        (dataStateChange)="dataStateChange(viewCases,$event)" [loading]="loadingCases">
                        <kendo-grid-messages noRecords="{{ 'NO-CASES' | translate }}">
                        </kendo-grid-messages>
                        <kendo-grid-column field="name" [width]="60" title="{{ 'CASE' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="channel" title="{{ 'CHANNEL' | translate }}" [width]="100">
                        </kendo-grid-column>
                        <kendo-grid-column field="openedOn" title="{{ 'OPENED-ON' | translate }}" [width]="50"
                            filter="date" format="{0:d}">
                        </kendo-grid-column>
                        <kendo-grid-column field="manager" title="{{ 'ASSIGNED-TO' | translate }}" [width]="50">
                        </kendo-grid-column>
                        <kendo-grid-column field="status" title="{{ 'CASE-STATUS' | translate }}" [width]="30">
                        </kendo-grid-column>
                    </kendo-grid>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item>
                <ng-template kendoPanelBarItemTitle>
                    {{'MEMBER' | translate:patientLabel }} {{'EXTENSIONS' | translate }}<span *ngIf="extensionCount > 0" class="badge-merge badge-pill badge-secondary"
                        title="{{'MEMBER' | translate:patientLabel }} {{'EXTENSIONS' | translate}}">{{extensionCount}}</span>
                </ng-template>
                <ng-template kendoPanelBarContent>
                    <kendo-grid [data]="viewExtensions.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
                        [sort]="viewExtensions.state.sort" [resizable]="true" class="max-grid-height"
                        (dataStateChange)="dataStateChange(viewExtensions,$event)" [loading]="viewExtensions.loading">
                        <kendo-grid-messages noRecords="{{ 'NO-EXTENSIONS' | translate }}">
                        </kendo-grid-messages>
                        <kendo-grid-column field="settingExtension.organization.name" [width]="50"
                            title="{{ 'SOURCE-ORGANIZATION' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="settingExtension.name" [width]="50" title="{{ 'NAME' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="value" [width]="20" title="{{ 'VALUE' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column *ngIf="context === 'source' && propertiesSelectorVisible" class="text-center"
                            field="selected" [width]="25"
                            title="{{ 'PATIENT-MERGE-SOURCE-DEMOGRAPHICS' | translate:patientLabel }}" filter="boolean">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span *ngIf="dataItem.value !== null">
                                    <input type="checkbox" [(ngModel)]="dataItem.selected" kendoCheckBox
                                        [disabled]="!propertiesSelectorEnabled" />
                                </span>
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item>
                <ng-template kendoPanelBarItemTitle>
                    {{'FLAGS' | translate }}<span *ngIf="flagCount > 0" class="badge-merge badge-pill badge-secondary"
                        title="{{'FLAGS' | translate}}">{{flagCount}}</span>
                </ng-template>
                <ng-template kendoPanelBarContent>
                    <kendo-grid [data]="viewFlags.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
                        [sort]="viewFlags.state.sort" [resizable]="true" class="max-grid-height"
                        (dataStateChange)="dataStateChange(viewFlags,$event)" [loading]="viewFlags.loading">
                        <kendo-grid-messages noRecords="{{ 'NO-FLAGS' | translate }}">
                        </kendo-grid-messages>
                        <kendo-grid-column field="description" [width]="60" title="{{ 'NAME' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="category.displayName" [width]="20"
                            title="{{ 'CATEGORY' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="priority.displayName" [width]="20"
                            title="{{ 'PRIORITY' | translate }}">
                        </kendo-grid-column>
                    </kendo-grid>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item *ngIf="goalsEnabled">
                <ng-template kendoPanelBarItemTitle>
                    {{'GOALS' | translate }}<span *ngIf="goalCount > 0" class="badge-merge badge-pill badge-secondary"
                        title="{{'GOALS' | translate}}">{{goalCount}}</span>
                </ng-template>
                <ng-template kendoPanelBarContent>
                    <kendo-grid [data]="viewGoals.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
                        [sort]="viewGoals.state.sort" [resizable]="true" class="max-grid-height"
                        (dataStateChange)="dataStateChange(viewGoals,$event)" [loading]="viewGoals.loading">
                        <kendo-grid-messages noRecords="{{ 'NO-GOAL' | translate }}">
                        </kendo-grid-messages>
                        <kendo-grid-column field="goal" [width]="60" title="{{ 'GOAL' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="type.displayName" [width]="20"
                            title="{{ 'TYPE-OF-GOAL' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="progress.displayName" [width]="20"
                            title="{{ 'PROGRESS' | translate }}">
                        </kendo-grid-column>
                    </kendo-grid>
                </ng-template>
            </kendo-panelbar-item>

            <kendo-panelbar-item *ngIf="insurancesEnabled">
                <ng-template kendoPanelBarItemTitle>
                    {{'INSURANCES' | translate }}<span *ngIf="insuranceCount > 0"
                        class="badge-merge badge-pill badge-secondary"
                        title="{{'INSURANCES' | translate}}">{{insuranceCount}}</span>
                </ng-template>
                <ng-template kendoPanelBarContent>
                    <kendo-grid [data]="viewInsurances.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
                        [sort]="viewInsurances.state.sort" [resizable]="true" class="max-grid-height"
                        (dataStateChange)="dataStateChange(viewInsurances,$event)" [loading]="loadingInsurances">
                        <kendo-grid-messages noRecords="{{ 'NO-INSURANCES' | translate }}">
                        </kendo-grid-messages>
                        <kendo-grid-column field="insurer" title="{{'INSURER' | translate}}" [width]="30">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span *ngIf="dataItem.insurer">{{dataItem.insurer.name}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="startDate" title="{{'START-DATE' | translate}}" [width]="25"
                            filter="date" format="{0:g}">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div
                                    *ngIf="dataItem.startDate !== null && dataItem.startDate !== undefined && !loading">
                                    {{ intl.formatDate(intl.parseDate(dataItem.startDate), "d") }}
                                </div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="endDate" title="{{'END-DATE' | translate}}" [width]="25" filter="date"
                            format="{0:g}">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <div *ngIf="dataItem.endDate !== null && dataItem.endDate !== undefined && !loading">
                                    {{ intl.formatDate(intl.parseDate(dataItem.endDate), "d") }}
                                </div>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="insuredFullName" title="{{ 'INSURED-NAME' | translate }}"
                            [width]="30">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span>{{dataItem.insuredGivenName}} {{dataItem.insuredFamilyName}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="insuranceMemberId" title="{{ 'INSURANCE-MEMBER-ID' | translate }}"
                            [width]="30">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span *ngIf="dataItem.insuranceMemberId">{{dataItem.insuranceMemberId}}</span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="plan" title="{{'PLAN' | translate}}" [width]="30">
                        </kendo-grid-column>
                        <kendo-grid-column field="groupId" title="{{'GROUP-ID' | translate}}" [width]="30">
                        </kendo-grid-column>
                        <kendo-grid-column field="insuranceExternalId" title="{{ 'INSURANCE-EXTERNAL-ID' | translate }}" [width]="30">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span *ngIf="dataItem.insuranceExternalId">{{dataItem.insuranceExternalId}}</span>
                            </ng-template>
                        </kendo-grid-column>
                    </kendo-grid>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item>
                <ng-template kendoPanelBarItemTitle>
                    {{'NOTES' | translate }}<span *ngIf="noteCount > 0" class="badge-merge badge-pill badge-secondary"
                        title="{{'NOTES' | translate}}">{{noteCount}}</span>
                </ng-template>
                <ng-template kendoPanelBarContent>
                    <kendo-grid [data]="viewNotes.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
                        [sort]="viewNotes.state.sort" [resizable]="true" class="max-grid-height"
                        (dataStateChange)="dataStateChange(viewNotes,$event)" [loading]="viewNotes.loading">
                        <kendo-grid-messages noRecords="{{ 'NO-NOTES' | translate }}">
                        </kendo-grid-messages>
                        <kendo-grid-column field="title" [width]="30" title="{{ 'TITLE' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="body" [width]="60" title="{{ 'DESCRIPTION' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="createdOn" title="{{ 'CREATED-DATE' | translate }}" [width]="20"
                            filter="date" format="{0:d}">
                        </kendo-grid-column>
                    </kendo-grid>
                </ng-template>
            </kendo-panelbar-item>
            <kendo-panelbar-item>
                <ng-template kendoPanelBarItemTitle>
                    {{'TASKS' | translate}}<span *ngIf="taskCount > 0" class="badge-merge badge-pill badge-secondary"
                        title="{{'TASKS' | translate}}">{{taskCount}}
                    </span>
                </ng-template>
                <ng-template kendoPanelBarContent>
                    <kendo-grid [data]="viewTasks.gridData" [selectable]="{ mode: 'single' }" [sortable]="true"
                        [sort]="viewTasks.state.sort" [resizable]="true" class="max-grid-height"
                        (dataStateChange)="dataStateChange(viewTasks,$event)" [loading]="loadingTasks">
                        <kendo-grid-messages noRecords="{{ 'NO-TASKS' | translate }}">
                        </kendo-grid-messages>
                        <kendo-grid-column field="name" [width]="60" title="{{ 'TASK' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="caseName" title="{{ 'CASE' | translate }}" [width]="80">
                        </kendo-grid-column>
                        <kendo-grid-column field="channel" title="{{ 'CHANNEL' | translate }}" [width]="110">
                        </kendo-grid-column>
                        <kendo-grid-column field="channelWorkflowStatus.displayName"
                            title="{{ 'CHANNEL-WORKFLOW-STATUS' | translate }}" [width]="80">
                        </kendo-grid-column>
                        <kendo-grid-column field="assigneeName" title="{{'ASSIGNED-TO' | translate}}" [width]="90">
                        </kendo-grid-column>
                        <kendo-grid-column field="openedOn" title="{{ 'OPENED-ON' | translate }}" [width]="50"
                            filter="date" format="{0:d}">
                        </kendo-grid-column>
                        <kendo-grid-column field="dueDate" title="{{ 'DUE-DATE' | translate }}" [width]="50"
                            filter="date" format="{0:d}">
                        </kendo-grid-column>
                    </kendo-grid>
                </ng-template>
            </kendo-panelbar-item>
        </kendo-panelbar>
    </div>
</div>

<app-document-viewer #documentViewer></app-document-viewer>